'use client';

import clsx from 'clsx';
import styles from './Pagination.module.scss';
import Button, { ButtonType } from '@/components/Button/Button';

interface PaginationProps {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  className?: string;
}

const Pagination = ({
  totalPages,
  currentPage,
  onPageChange,
  className,
}: PaginationProps) => {
  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const next = () => {
    handlePageChange(currentPage + 1);
  };

  const previous = () => {
    handlePageChange(currentPage - 1);
  };

  const renderDots = () => Array.from({ length: totalPages }, (_, i) => (
    <button
      key={i}
      type='button'
      className={clsx(styles.dot, {
        [styles.active]: i + 1 === currentPage,
      })}
      onClick={() => handlePageChange(i + 1)}
    >
      <span>{' '}</span>
    </button>
  ));

  if (totalPages === 1) return null;

  return (
    <div className={clsx(styles.pagination, className)}>
      <div className={styles.dots}>
        {renderDots()}
      </div>
      <div className={styles.buttons}>
        <Button
          type={ButtonType.SECONDARY_LIGHT}
          iconName='arrow_back'
          onClick={previous}
          disabled={currentPage <= 1}
        />
        <Button
          type={ButtonType.SECONDARY_LIGHT}
          iconName='arrow_forward'
          onClick={next}
          disabled={currentPage >= totalPages}
        />
      </div>
    </div>
  );
};

export default Pagination;
